import { createAction, props } from '@ngrx/store';

export const loadRegulatorySettingsFirstTimeCustomers = createAction(
  '[RegulatorySettingsFirstTimeCustomer] Load RegulatorySettingsFirstTimeCustomers'
);

export const loadRegulatorySettingsFirstTimeCustomersSuccess = createAction(
  '[RegulatorySettingsFirstTimeCustomer] Load RegulatorySettingsFirstTimeCustomers Success',
  props<{ response: any }>()
);

export const loadRegulatorySettingsFirstTimeCustomersFailure = createAction(
  '[RegulatorySettingsFirstTimeCustomer] Load RegulatorySettingsFirstTimeCustomers Failure',
  props<{ error: Error | any }>()
);
